interface Props {
  overlay: React.ReactNode,
  children: React.ReactNode,
  setReferenceElement: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>
  setPopperElement: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>
  styles: {
    [key: string]: React.CSSProperties;
  }
  attributes:  {
    [key: string]: {
      [key: string]: string;
    } | undefined;
  }
  refPopper: React.RefObject<HTMLDivElement>
  isOpen: boolean
  setisOpen: React.Dispatch<React.SetStateAction<boolean>>
}
const Dropdownactions = ({
  overlay,
  children,
  setReferenceElement,
  setPopperElement,
  styles,
  attributes,
  refPopper,
  isOpen,
  setisOpen }: Props) => {
  return (
    <div className="c-dropdown" ref={refPopper}>
      <div className="c-dropdown__children" ref={setReferenceElement} onClick={() => setisOpen(o => !o)}>
        {children}
      </div>
      <div className={`c-dropdown__overley ${isOpen && `c-dropdown__overley--active`}`}
        ref={setPopperElement}
        style={styles.popper}
        {...attributes.popper}
      >
        <div className={`c-dropdown__content ${isOpen && `c-dropdown__content--active`}`}>
          {overlay}
        </div>
      </div>
    </div>
  )
}

export default Dropdownactions